// extracted by mini-css-extract-plugin
module.exports = {"service-tabs":"ServiceTabs_service-tabs__2O6HX","tab":"ServiceTabs_tab__1oDqf","active":"ServiceTabs_active__36l1R"};